import AntdDrawer, { type DrawerProps as AntdDrawerProps } from "antd/lib/drawer";
import { FC } from "react";

export type DrawerProps = AntdDrawerProps;

export const Drawer: FC<DrawerProps> = props => {
    return <AntdDrawer {...props} />;
};
